import { useContext, useEffect } from 'react';
import { Typography, Button, Spinner } from "@material-tailwind/react";
import CreatableSelect from 'react-select/creatable';
import { NewContext } from '../../Context/NewContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { toast } from 'react-toastify';
import { add_ai_config, update_ai_config } from '../../Controller/actions';

export const ConfigModel = () => {
    const { isModalLoading, handleClose, handleChange, formData, open, addEditDeleteTag, setIsModalLoading, setFormData, selectedAiConfigMangerOption, setSelectedAiConfigMangerOption } = useContext(NewContext);

    const options = [
        { value: 'generativeFill', label: 'generativeFill' },
        { value: 'textToImage', label: 'textToImage' },
        { value: 'promptGenerator', label: 'promptGenerator' },
        { value: 'maskImage', label: 'maskImage' },

    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        let createUpdateAiConfigManger;
        setIsModalLoading(true);

        if (addEditDeleteTag === "update") {
            createUpdateAiConfigManger = await update_ai_config({ ...formData, title: selectedAiConfigMangerOption.value }, formData?._id);
        } else {
            createUpdateAiConfigManger = await add_ai_config({ ...formData, title: selectedAiConfigMangerOption.value });
        }
        setIsModalLoading(false);
        if (createUpdateAiConfigManger) {
            const { message, status } = createUpdateAiConfigManger;
            if (status === true) {
                toast.success(message);
                setFormData([]);
                handleClose();
                setSelectedAiConfigMangerOption(null);
                handleClose();
            } else {
                toast.error(message);
            }
        }
    };

    useEffect(() => {
        setFormData({ ...formData });
    }, [setFormData]);

    useEffect(() => {
        if (formData && formData.title) {
            setSelectedAiConfigMangerOption({ value: formData.title, label: formData.title });
        }
    }, [addEditDeleteTag]);

    return (
        <>
            <Dialog
                open={open}
                onClose={() => { handleClose(); setSelectedAiConfigMangerOption([]); }}
                aria-labelledby="responsive-dialog-title"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            height: "100%",
                            maxWidth: "400px",
                            maxHeight: "320px",
                            borderRadius: "12px"
                        },
                    },
                }}
            >
                <DialogTitle id="responsive-dialog-title" className='p-0 mb-[30px] text-[#1E1627]'>
                    {
                        addEditDeleteTag === 'view' ? 'Details View' : addEditDeleteTag === 'update' ? `Edit AI Config` : `Add AI Config`
                    }
                </DialogTitle>
                <DialogContent>
                    <div>
                        {
                            addEditDeleteTag !== 'view' ?
                                <form onSubmit={handleSubmit}>
                                    <div className="mt-5 grid grid-cols-1 lg:grid-cols-6 gap-5 add-edit-form">
                                        <div className="sm:col-span-6">
                                            <div className='mt-2'>
                                                <label htmlFor="Title" name='title' className="block text-sm font-medium leading-6 text-gray-900">API Name:<span className='text-red-800'>*</span></label>
                                                <CreatableSelect
                                                    required
                                                    options={options}
                                                    value={selectedAiConfigMangerOption}
                                                    onChange={(selectedAiConfigMangerOption) => {
                                                        setSelectedAiConfigMangerOption(selectedAiConfigMangerOption);
                                                    }}
                                                />
                                            </div>
                                            <label htmlFor="description" className="block  font-medium leading-5 mt-4">URL:<span className='text-red-800'>*</span></label>
                                            <div className="mt-2">
                                                <input className=' w-full border px-3 py-2 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500' id='description' required placeholder='Enter URL' name='description' onChange={handleChange} value={formData?.description} autoComplete='off' />
                                            </div>


                                        </div>
                                    </div>
                                    <div className='flex justify-end mt-3'>
                                        <Button onClick={() => { handleClose() }} className="mr-1 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                        >
                                            <span>Cancel</span>
                                        </Button>
                                        <Button className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                                            type='submit'
                                        >
                                            {isModalLoading && <Spinner className="h-4 w-4" />}
                                            <span className={isModalLoading && 'ml-4'}>{addEditDeleteTag === `add` ? `Add` : `Update`}</span>
                                        </Button>
                                    </div>
                                </form>
                                :
                                <div>
                                    <div className="mt-5 grid grid-cols-1 lg:grid-cols-6 gap-5 add-edit-form">
                                        <div className="sm:col-span-6">
                                            <label htmlFor="name" className="block text-lg font-medium leading-5 text-[#1E3354]">Title:</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5" autoComplete="off">{formData?.title || `None`}</Typography>
                                            </div>
                                        </div>
                                        <div className="sm:col-span-6">
                                            <label htmlFor="URL" className="block text-lg font-medium leading-5 text-[#1E3354]">URL:</label>
                                            <div className="mt-2">
                                                <Typography className="text-[17px] text-[#75869F] font-normal leading-5 capitalize break-words">{formData?.description || `None`}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-end mt-5'>
                                        <Button
                                            onClick={() => { handleClose(); setSelectedAiConfigMangerOption([]); setFormData({}) }}
                                            className="mr-1 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                                        >
                                            <span>Cancel</span>
                                        </Button>
                                    </div>
                                </div>
                        }
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ConfigModel;
